import React from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import DashboardIndex from "../components/dashboard";
import { Link } from "react-router-dom";
import AppOverviewIndex from "../components/app-overview";


const AppOverviewScreen = (props) => (
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title={props.location.state.name} subtitle="F-Fort" md="12" className="ml-sm-auto mr-sm-auto" />
    </Row>
    <AppOverviewIndex data={props.location.state}/>
    
  </Container>
);

export default AppOverviewScreen;
